module.exports = __webpack_public_path__ + "static/aboutus-3797877665ebdbeb1256a0ff5d84d0ea.jpg";